import * as Departments from 'Modules/DepartmentModule';
import { Department } from '../EnumTypes/ActionEnumTypes';
import { toast } from 'react-toastify';
import { SVG } from 'Components';
import { SVG_TYPE } from 'Shared/enums';

const init = () => ({
  type: Department.DELETE_DEPARTMENT_INIT,
});

export const success = (data) => ({
  type: Department.DELETE_DEPARTMENT_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: Department.DELETE_DEPARTMENT_FAILURE,
});

const deleteDepartment = (uuid) => async (dispatch) => {
  dispatch(init());
  const id = toast.loading('Trwa usuwanie działu...');
  try {
    const response = await Departments.Connector.deleteDepartment(uuid);
    dispatch(success(response.data));
    toast.update(id, {
      render: 'Pomyślnie usunięto dział',
      type: toast.TYPE.SUCCESS,
      isLoading: false,
      closeButton: true,
      autoClose: 3000,
      icon: <SVG variant={SVG_TYPE.CIRCLE_GREEN} type={SVG_TYPE.CHECKED} />,
    });
    dispatch(success(response.data));
    return response.data;
  } catch (err) {
    dispatch(failure());
    toast.update(id, {
      render: 'Nie udało się usunąć działu',
      type: toast.TYPE.SUCCESS,
      isLoading: false,
      closeButton: true,
      autoClose: 3000,
      icon: <SVG variant={SVG_TYPE.CIRCLE_GREEN} type={SVG_TYPE.CHECKED} />,
    });
    return false;
  }
};

export default deleteDepartment;
